<template>
  <div>
    <!-- BEGIN type competence choice -->
    <div class="flex justify-center my-8 w-full">
      <div
        class="flex relative cursor-pointer items-center w-max"
        @click="displayTypeCompetenceChoice"
        @click.stop
      >
        <div class="text-xl text-indigo-600">
          {{ typeCompetenceChosen }}
        </div>

        <div
          class="text-pink-600 max-h-8 mr-auto rounded-full inline-flex items-center p-2 order-2"
        >
          <icon
            v-if="
              (Object.values(form.items.competences_bases.savoirs).length > 0 ||
                Object.values(form.items.competences_bases.savoir_faire)
                  .length > 0) &&
              (Object.values(form.items.competences_spe.savoirs).length > 0 ||
                Object.values(form.items.competences_spe.savoir_faire).length >
                  0)
            "
            class="h-4 w-4"
            name="chevron-down"
          />
        </div>
        <div
          v-if="showTypeCompetenceChoice"
          class="absolute flex fieldlist z-20 w-max-content w-max mt-2 top-8 right-0 text-sm rounded-md bg-white shadow-md shadow-gray-600"
          v-click-outside="displayTypeCompetenceChoice"
        >
          <div class="mx-5 my-3">
            <div class="text-left">
              <div class="pt-2 pb-1">
                <p
                  class="text-gray-600 hover:text-gray-900"
                  @click="typeCompetenceChosen = 'Compétences de base'"
                >
                  Compétences de base
                </p>
              </div>
              <div class="py-1">
                <p
                  class="text-gray-600 hover:text-gray-900"
                  @click="typeCompetenceChosen = 'Compétences spécifiques'"
                >
                  Compétences spécifiques
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END type competence choice -->

    <!-- BEGIN Compétences de base -->
    <div v-if="typeCompetenceChosen === 'Compétences de base'">
      <rome-evaluation-header
        class="md:mx-10"
        :can-hide-auto="evalReferentVisibility && !historyMode"
        :id-pass="idPass"
        :id-user="idUser"
        :is-hidden-value1="
          hiddenFields['base_savoir_faire_auto'] && !historyMode
        "
        :visibility-value2="evalReferentVisibility"
        :is-hidden-last-eval="
          hiddenFields['base_savoir_faire_last'] && !historyMode
        "
        :is-lastest-evaluation-visible="evalReferentVisibility && !historyMode"
        @hideValue1="
          hiddenFields['base_savoir_faire_auto'] =
            !hiddenFields['base_savoir_faire_auto']
        "
        @hideLastestEvaluation="
          hiddenFields['base_savoir_faire_last'] =
            !hiddenFields['base_savoir_faire_last']
        "
      />
      <rome-evaluation-grid
        class="my-4 md:my-8 md:mx-10"
        title="Savoir-Faire"
        :list="form.items.competences_bases.savoir_faire"
        :lib-keys="['auto', 'value']"
        :lastest-evaluation="
          lastestEvaluation?.items?.competences_bases?.savoir_faire
        "
        :is-lastest-evaluation-visible="evalReferentVisibility && !historyMode"
        @changeValue1="
          (infos) => {
            $emit('changeValue', {
              typeCompetence: 'competences_bases',
              typeSavoir: 'savoir_faire',
              evaluatorType: 'auto',
              value: infos,
            });
          }
        "
        @changeValue2="
          (infos) => {
            $emit('changeValue', {
              typeCompetence: 'competences_bases',
              typeSavoir: 'savoir_faire',
              evaluatorType: 'value',
              value: infos,
            });
          }
        "
        :is-disabled="isDisabled"
        :is-disabled-value1="!autoEvalEditable"
        :visibility-value1="
          idPass == idUser ||
          !hiddenFields['base_savoir_faire_auto'] ||
          historyMode
        "
        :visibility-last-eval="!hiddenFields['base_savoir_faire_last']"
        :visibility-value2="evalReferentVisibility"
      />
      <rome-evaluation-header
        class="md:mx-10"
        :can-hide-auto="evalReferentVisibility && !historyMode"
        :id-pass="idPass"
        :id-user="idUser"
        :is-hidden-value1="hiddenFields['base_savoirs_auto'] && !historyMode"
        :visibility-value2="evalReferentVisibility"
        :is-hidden-last-eval="hiddenFields['base_savoirs_last'] && !historyMode"
        :is-lastest-evaluation-visible="evalReferentVisibility && !historyMode"
        @hideValue1="
          hiddenFields['base_savoirs_auto'] = !hiddenFields['base_savoirs_auto']
        "
        @hideLastestEvaluation="
          hiddenFields['base_savoirs_last'] = !hiddenFields['base_savoirs_last']
        "
      />
      <rome-evaluation-grid
        class="my-4 md:my-8 md:mx-10"
        title="Savoirs"
        :list="form.items.competences_bases.savoirs"
        :lib-keys="['auto', 'value']"
        :lastest-evaluation="
          lastestEvaluation?.items?.competences_bases?.savoirs
        "
        :is-lastest-evaluation-visible="evalReferentVisibility && !historyMode"
        @changeValue1="
          (infos) => {
            $emit('changeValue', {
              typeCompetence: 'competences_bases',
              typeSavoir: 'savoirs',
              evaluatorType: 'auto',
              value: infos,
            });
          }
        "
        @changeValue2="
          (infos) => {
            $emit('changeValue', {
              typeCompetence: 'competences_bases',
              typeSavoir: 'savoirs',
              evaluatorType: 'value',
              value: infos,
            });
          }
        "
        :is-disabled="isDisabled"
        :is-disabled-value1="!autoEvalEditable"
        :visibility-value1="
          idPass == idUser || !hiddenFields['base_savoirs_auto'] || historyMode
        "
        :visibility-last-eval="!hiddenFields['base_savoirs_last']"
        :visibility-value2="evalReferentVisibility"
      />
    </div>
    <!-- END Compétences de base -->

    <!-- BEGIN Compétences spécifiques -->
    <div v-if="typeCompetenceChosen === 'Compétences spécifiques'">
      <rome-evaluation-header
        class="md:mx-10"
        :can-hide-auto="evalReferentVisibility && !historyMode"
        :id-pass="idPass"
        :id-user="idUser"
        :is-hidden-value1="
          hiddenFields['spe_savoir_faire_auto'] && !historyMode
        "
        :visibility-value2="evalReferentVisibility"
        :is-hidden-last-eval="
          hiddenFields['spe_savoir_faire_last'] && !historyMode
        "
        :is-lastest-evaluation-visible="evalReferentVisibility && !historyMode"
        @hideValue1="
          hiddenFields['spe_savoir_faire_auto'] =
            !hiddenFields['spe_savoir_faire_auto']
        "
        @hideLastestEvaluation="
          hiddenFields['spe_savoir_faire_last'] =
            !hiddenFields['spe_savoir_faire_last']
        "
      />
      <rome-evaluation-grid
        class="my-4 md:my-8 md:mx-10"
        title="Savoir-Faire"
        :list="form.items.competences_spe.savoir_faire"
        :lib-keys="['auto', 'value']"
        :lastest-evaluation="
          lastestEvaluation?.items?.competences_spe?.savoir_faire
        "
        :is-lastest-evaluation-visible="evalReferentVisibility && !historyMode"
        @changeValue1="
          (infos) => {
            $emit('changeValue', {
              typeCompetence: 'competences_spe',
              typeSavoir: 'savoir_faire',
              evaluatorType: 'auto',
              value: infos,
            });
          }
        "
        @changeValue2="
          (infos) => {
            $emit('changeValue', {
              typeCompetence: 'competences_spe',
              typeSavoir: 'savoir_faire',
              evaluatorType: 'value',
              value: infos,
            });
          }
        "
        :is-disabled="isDisabled"
        :is-disabled-value1="!autoEvalEditable"
        :visibility-value1="
          idPass == idUser ||
          !hiddenFields['spe_savoir_faire_auto'] ||
          historyMode
        "
        :visibility-last-eval="!hiddenFields['spe_savoir_faire_last']"
        :visibility-value2="evalReferentVisibility"
      />
      <rome-evaluation-header
        class="md:mx-10"
        :can-hide-auto="evalReferentVisibility && !historyMode"
        :id-pass="idPass"
        :id-user="idUser"
        :is-hidden-value1="hiddenFields['spe_savoirs_auto'] && !historyMode"
        :visibility-value2="evalReferentVisibility"
        :is-hidden-last-eval="hiddenFields['spe_savoirs_last'] && !historyMode"
        :is-lastest-evaluation-visible="evalReferentVisibility && !historyMode"
        @hideValue1="
          hiddenFields['spe_savoirs_auto'] = !hiddenFields['spe_savoirs_auto']
        "
        @hideLastestEvaluation="
          hiddenFields['spe_savoirs_last'] = !hiddenFields['spe_savoirs_last']
        "
      />
      <rome-evaluation-grid
        class="my-4 md:my-8 md:mx-10"
        title="Savoirs"
        :list="form.items.competences_spe.savoirs"
        :lib-keys="['auto', 'value']"
        :lastest-evaluation="lastestEvaluation?.items?.competences_spe?.savoirs"
        :is-lastest-evaluation-visible="evalReferentVisibility && !historyMode"
        @changeValue1="
          (infos) => {
            $emit('changeValue', {
              typeCompetence: 'competences_spe',
              typeSavoir: 'savoirs',
              evaluatorType: 'auto',
              value: infos,
            });
          }
        "
        @changeValue2="
          (infos) => {
            $emit('changeValue', {
              typeCompetence: 'competences_spe',
              typeSavoir: 'savoirs',
              evaluatorType: 'value',
              value: infos,
            });
          }
        "
        :is-disabled="isDisabled"
        :is-disabled-value1="!autoEvalEditable"
        :visibility-value1="
          idPass == idUser || !hiddenFields['spe_savoirs_auto'] || historyMode
        "
        :visibility-last-eval="!hiddenFields['spe_savoirs_last']"
        :visibility-value2="evalReferentVisibility"
      />
    </div>
    <!-- END Compétences spécifiques -->
  </div>
  <!-- END Remplir avec le modèle de page correspondant -->
</template>

<script>
import RomeEvaluationGrid from './RomeEvaluationGrid.vue';
import RomeEvaluationHeader from './RomeEvaluationHeader.vue';
import Icon from '../Icon.vue';

export default {
  components: {
    RomeEvaluationHeader,
    RomeEvaluationGrid,
    Icon,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    idPass: {
      type: String,
      required: false,
      default: '',
    },
    idUser: {
      type: Number,
    },
    historyMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    lastestEvaluation: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      typeCompetenceChosen: 'Compétences de base',
      showTypeCompetenceChoice: false,
      hiddenFields: {
        base_savoir_faire_auto: true,
        base_savoirs_auto: true,
        spe_savoir_faire_auto: true,
        spe_savoirs_auto: true,

        base_savoir_faire_last: true,
        base_savoirs_last: true,
        spe_savoir_faire_last: true,
        spe_savoirs_last: true,
      },
    };
  },

  methods: {
    displayTypeCompetenceChoice() {
      this.showTypeCompetenceChoice = !this.showTypeCompetenceChoice;
    },
  },

  computed: {
    autoEvalEditable() {
      let isNeopassOwner = parseInt(this.idPass) === this.idUser,
        canEdit = this.$can('comppro_auto_eval_edit', this.idPass);
      return isNeopassOwner || canEdit;
    },

    evalReferentVisibility() {
      return parseInt(this.idPass) !== this.idUser;
    },
  },
};
</script>
